import React from 'react';
import mockMayhemWorkouts from './mockMayhemWorkouts';
const ProgramService = {
  convertToString(list) {
    if (Array.isArray(list)) {
      return list.map(i => i.value).join(',');
    }
    return list;
  },
  async saveProgram(formData) {
    try {
      let url = '/api/wod/program';
      let method = 'POST';
      const profileLogged = JSON.parse(localStorage.getItem('profile'));
      const { accountIdentifier } = profileLogged;
      if (formData.identifier !== undefined) {
        url = '/api/wod/program/' + formData.identifier;
        method = 'PUT';
      }
      const updatedData = {
        ...formData,
        tags: this.convertToString(formData.tags),
        exercises: this.convertToString(formData.exercises),
        accountIdentifier: accountIdentifier
      };
      console.log('Updated Data to be sent:', updatedData);
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updatedData)
      });
      if (response.ok) {
        const newProgram = await response.json();
        console.log('Program has been updated:', newProgram);
      }
    } catch (error) {
      console.log('Error saving Program', error);
    }
  },
  async generateProgramFromAI(excerises) {
    //const accountIdentifier = JSON.parse(localStorage.getItem('profile')).accountIdentifier;
    const payload = {
      exercises: excerises,
      style: 'For Time',
      focus: 'Strength',
      equipment: 'Barbell',
      duration: '20 minutes',
      teamFormat: false
    };
    try {
      const response = await fetch(
        'https://codersden.app.n8n.cloud/webhook/9c02ea4d-4b30-4668-ac83-d0ccd9a76bcb',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        }
      );
      if (response.ok) {
        const generatedProgram = await response.json();
        return generatedProgram;
      } else {
        console.error('Error generating program from AI:', response.statusText);
        throw new Error('Failed to generate program from AI');
      }
    } catch (error) {
      console.log('Error generating program from AI', error);
      throw error;
    }
  },
  async createProgramClassFromPDF(data) {
    try {
      const updatedData = {
        ...data,
        accountIdentifier: JSON.parse(localStorage.getItem('profile')).accountIdentifier,
        source: 'Mayhem Weekly Workout',
        name: data.date + ' - ' + 'CrossFit Mayhem',
        type: 'CrossFit'
      }
      console.log('Data to be sent for creating program class:', updatedData);  
      const response = await fetch('/api/wod/program', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updatedData)
      });
      if (response.ok) {
        const newClass = await response.json();
        console.log('Program class created successfully:', newClass);
        return newClass;
      } else {
        console.error('Error creating program class:', response.statusText);
        throw new Error('Failed to create program class');
      }
    } catch (error) {
      console.error('Error creating program class:', error);
      throw error;
    }
  },
    async createProgramClassFromHyroxPDF(data) {
    try {
      const updatedData = {
        ...data,
        accountIdentifier: JSON.parse(localStorage.getItem('profile')).accountIdentifier,
        source: 'hyroxs.com',
        name: data.date + ' - ' + 'Hyrox',
        type: 'Hyrox'
      }
      console.log('Data to be sent for creating program class:', updatedData);  
      const response = await fetch('/api/wod/program', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updatedData)
      });
      if (response.ok) {
        const newClass = await response.json();
        console.log('Program class created successfully:', newClass);
        return newClass;
      } else {
        console.error('Error creating program class:', response.statusText);
        throw new Error('Failed to create program class');
      }
    } catch (error) {
      console.error('Error creating program class:', error);
      throw error;
    }
  },
    async uploadHyroxPDFFile(file) {
    const formData = new FormData();
    formData.append('file0', file);
    try {
      const url = 'https://codersden.app.n8n.cloud/webhook/29f6d4b1-a452-4df7-a4a5-0a47b9d2e75b'; 
      const response = await fetch(url, {
        method: 'POST',
        body: formData
      });
      if (response.ok) {
        const data = await response.json();
        return data;
      } else {
        console.error('Error uploading PDF file:', response.statusText);
        throw new Error('Failed to upload PDF file');
      }
    } catch (error) {
      console.log('Error uploading PDF file', error);
      throw error;
    }
  },
  async uploadPDFFile(file) {
    const formData = new FormData();
    formData.append('file0', file);
    try {
      const url = 'https://codersden.app.n8n.cloud/webhook/load-weekly-workouts'; 
      // const data = mockMayhemWorkouts;
      // return data; 
      const response = await fetch(url, {
        method: 'POST',
        body: formData
      });
      if (response.ok) {
        const data = await response.json();
        return data;
      } else {
        console.error('Error uploading PDF file:', response.statusText);
        throw new Error('Failed to upload PDF file');
      }
    } catch (error) {
      console.log('Error uploading PDF file', error);
      throw error;
    }
  },
  async retrieveAllProgramByAccount() {
    try {
      const { accountIdentifier } = JSON.parse(localStorage.getItem('profile'));
      console.log(accountIdentifier);
      const response = await fetch(
        '/api/wod/program/account/' + accountIdentifier
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching Program', error);
      throw error;
    }
  },
  async retrieveProgram(identifier) {
    try {
      const response = await fetch('/api/wod/program/' + identifier);
      const data = await response.json();

      return data;
    } catch (error) {
      console.error('Error fetching Program', error);
      throw error;
    }
  },
  async deleteProgram(identifier) {
    try {
      let url = '/api/wod/program/' + identifier;
      let method = 'DELETE';
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      if (response.ok) {
        const newProgram = await response.json();
        console.log('Program has been deleted:', newProgram);
      }
    } catch (error) {
      console.log('Error deleting Program', error);
    }
  }
};
export default ProgramService;
